import { Alert, Button, Stack } from '@mui/material'
import { MESSAGES } from './chrome/chartChrome'

interface Props {
  natural: number
  effectiveCap: number
  defaultCap: number
  onIncreaseCap: () => void
  onResetCap: () => void
}

export function TruncatedBanner({
  natural,
  effectiveCap,
  defaultCap,
  onIncreaseCap,
  onResetCap,
}: Props) {
  return (
    <Alert severity="warning" sx={{ alignItems: 'center' }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <span>{MESSAGES.truncatedPanels(effectiveCap, natural)}</span>
        <Button size="small" onClick={onIncreaseCap}>
          {MESSAGES.showMore}
        </Button>
        {effectiveCap !== defaultCap ? (
          <Button size="small" color="inherit" onClick={onResetCap}>
            {MESSAGES.resetCap}
          </Button>
        ) : null}
      </Stack>
    </Alert>
  )
}
